import { MenuItem } from "./menu.model";

const menu = [
  {
    id: 1,
    label: "MENUITEMS.MENU.TEXT",
    isTitle: true,
    tag: ["--general"],
  },
  {
    id: 9,
    label: "Control Center",
    icon: "bx-home-circle",
    link: "/dashboard",
    tag: ["--admin", "--super-admin"],
  },
  // {
  //   id: 9,
  //   label: "My Dashboard",
  //   icon: "bx-home-circle",
  //   link: "/dashboards/my-dashboard",
  //   tag: ["--agent"],
  // },
  {
    id: 9,
    label: "Marketers",
    icon: "bx-home-circle",
    link: "/marketer/agent-marketer-listings",
    tag: ["--agent"],
  },
  {
    id: 9,
    label: "Collections",
    icon: "bx-home-circle",
    link: "/collection/agent-collections",
    tag: ["--agent"],
  },
  {
    id: 9,
    label: "Flexi Payment",
    icon: "bx-home-circle",
    link: "/collection/agent-flexi-payment",
    tag: ["--agent"],
  },
  {
    id: 9,
    label: "Revenue",
    icon: "bx-home-circle",
    link: "/collection/agent-collection-revenue",
    tag: ["--agent"],
  },
  {
    id: 9,
    label: "Defaulters",
    icon: "bx-home-circle",
    link: "/collection/agent-collection-defaulters",
    tag: ["--agent"],
  },
  {
    id: 9,
    label: "My Wallet",
    icon: "bx-home-circle",
    link: "/staff/my-wallet",
    tag: ["--agent"],
  },
  {
    id: 9,
    label: "My Profile",
    icon: "bx-home-circle",
    link: "/staff/my-profile",
    tag: ["--agent"],
  },
  {
    id: 9,
    label: "Markets",
    icon: "bx-home-circle",
    link: "/market/market-listings",
    tag: ["--admin", "--super-admin"],
  },
  {
    id: 9,
    label: "Marketers",
    icon: "bx-home-circle",
    link: "/marketer/marketer-listings",
    tag: ["--admin", "--super-admin"],
  },
  {
    id: 9,
    label: "Leases",
    icon: "bx-home-circle",
    link: "/rents/rent-listings",
    tag: ["--admin", "--super-admin"],
  },
  {
    id: 12,
    label: "Shop",
    icon: "bx-store",
    tag: ["--admin", "--super-admin"],
    subItems: [
      {
        id: 13,
        label: "Shop List",
        link: "/shop/shop-listings",
        parentId: 12,
      },
      {
        id: 13,
        label: "Shop Types",
        link: "/shop/shop-type",
        parentId: 12,
      },
    ],
  },

  {
    id: 9,
    label: "Collections",
    icon: "bx-home-circle",
    link: "/collection/collections",
    tag: ["--admin", "--super-admin"],
  },
  {
    id: 9,
    label: "Staff",
    icon: "bx-home-circle",
    link: "/staff/staff-listings",
    tag: ["--admin", "--super-admin"],
  },

  {
    id: 9,
    label: "Back To Markets",
    icon: "bx-home-circle",
    link: "/select-market",
    tag: ["--admin", "--super-admin"],
  },
];

// user_role array
const userRoleArr: any = [];
const userTypedata: any = localStorage.getItem("currentUser");
const userType =
  userTypedata !== null && userTypedata !== undefined
    ? JSON.parse(userTypedata)
    : null;
userRoleArr.push(userType?.role ?? null);
console.log("🚀 ~ userRoleArr:", userRoleArr);

// create menu
const newMenu: any = [];

// loop through
menu.forEach((row: any) => {
  const menuTags = row.tag;
  // loop through user roles
  for (let u = 0; u < userRoleArr.length; u++) {
    const userRole = userRoleArr[u];
    console.log("🚀 ~ userRole:", userRole);
    if (menuTags) {
      if (userRole !== null && userRole == "super_admin") {
        for (let i = 0; i < menuTags.length; i++) {
          if (row.tag == "--general" || menuTags[i] == "--admin") {
            newMenu.push(row);
          }
        }
      } else if (userRole !== null && userRole == "admin") {
        for (let i = 0; i < menuTags.length; i++) {
          if (row.tag == "--general" || menuTags[i] == "--admin") {
            newMenu.push(row);
          }
        }
      } else if (userRole !== null && userRole == "agent") {
        if (row.tag == "--general" || row.tag == "--agent") {
          newMenu.push(row);
        }
      }
    }
  }
});

console.log("🚀 ~ newMenu:", newMenu);

export const GLOBAL_MENU: MenuItem[] = newMenu;
